import apiClient from '@/services/rest-api-sms/apiClient'
const baseEndpoint = '/vehicle'

export const unassignDevice = async (data, id, region) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/${id}/device`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const changeDevice = async (data, id, region) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}/device`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const get = async (queryParam, serverRegion) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
    headers: {
      'X-Region': serverRegion,
    },
  })

  return response?.data
}

export const unassignVehicleChild = async (data, serverRegion) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}/hierarchy`,
    headers: {
      'X-Region': serverRegion,
    },
    data,
  })

  return response
}

export const updateMultiImeiParent = async (id, data, region) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}/parent`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const updateMultiImeiChild = async (id, data, region) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}/child`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const update = async (id, data, region) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const addMultiImei = async (data, region) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/hierarchy`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const importMultiImei = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/hierarchy/import`,
    data: data,
  })

  return response
}

export const create = async (data, region = 'SG') => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    headers: {
      'X-Region': region,
    },
    data: data,
  })

  return response
}

function getFileNameFromHeader(headers) {
  const contentDisposition = headers['content-disposition']
  if (!contentDisposition) return null
  const match = contentDisposition.match(/filename="?(.+)"?/)
  return match ? match[1] : null
}

export const downloadMultiImei = async (params, serverRegion) => {
  try {
    const res = await apiClient({
      method: 'GET',
      url: `${baseEndpoint}/hierarchy/export`,
      responseType: 'blob',
      params: params,
      headers: {
        'X-Region': serverRegion,
      },
    })
    return {
      success: true,
      data: res.data,
      fileName: getFileNameFromHeader(res.headers) || 'ExportMultiImei.xlsx',
    }
  } catch (error) {
    console.error('Download gagal', error)
    return { success: false, error }
  }
}

export const assignDevice = async (data, vehicleId) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/${vehicleId}/device`,
    data: data,
  })

  return response
}

export const updateVehicleVgroups = async (data, vehicleId) => {
  const response = await apiClient({
    method: 'PUT',
    url: `${baseEndpoint}/${vehicleId}/vgroups`,
    data: data,
  })

  return response
}


export const detail = async (vehicleId) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${vehicleId}`,
  })

  return response?.data
}
